import { render } from "./CardThirtyFour.vue?vue&type=template&id=3d2b8090"
import script from "./CardThirtyFour.vue?vue&type=script&lang=js"
export * from "./CardThirtyFour.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__